import React from 'react';

import { FormattedMessage } from 'react-intl';

export default function SupplementalCoverage({ link, exchangeName }: { link: string, exchangeName: string }) {
    return (
        <>
            <div className="grid-row">
                <h4 id="supplemental_coverage_header">
                    <FormattedMessage
                        id="indportal.dashboard.plans.supplementalCoverage.header"
                        data-automation-id="supplemental_coverage_header"
                    />
                </h4>
            </div>
            <div className="">
                <FormattedMessage
                    id="indportal.dashboard.supplementalCoverage.description"
                    values={{ exchangeName }}
                    data-automation-id="supplemental_coverage_description"
                />{' '}
                <br />
                <a href={link} target="_blank">
                    <FormattedMessage
                        id="common.clickHereStandalone"
                        data-automation-id="supplemental_coverage_link"
                    />
                </a>{' '}
                <FormattedMessage id="indportal.dashboard.supplementalCoverage.cta" />
            </div>
        </>
    );
}
